import {defineMessages} from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'GuideNotAvailable.title',
    defaultMessage: 'Guide not available'
  },
  description: {
    id: 'GuideNotAvailable.description',
    defaultMessage: 'This guide is not available in the current workspace'
  }
});

export default messages;
